module.exports = __webpack_public_path__ + "static/assets/d55a7f7a4e953f4643f7a6051950b566.svg";